import { createSlice } from '@reduxjs/toolkit';
import { SLICES } from '../../constants/slices';

const initialState = {
  vetDetailsList: [], // vet details list
  newlyAddedVets: [] // new added vets
};

const vetDetailsSlice = createSlice({
  name: SLICES.VET_DETAILS,
  initialState,
  reducers: {
    setVetDetailsList: (state, action) => {
      state.vetDetailsList = action.payload;
    },
    setNewlyAddedVets: (state, action) => {
      const { activeVet, petsTreated } = action.payload;
      state.newlyAddedVets.push({ activeVet, petsTreated }); // Add new vet details to the array
    },
    clearNewlyAddedVets: (state) => {
      state.newlyAddedVets = []; // Clear the list
    }
  }
});

export const { setVetDetailsList, setNewlyAddedVets, clearNewlyAddedVets } = vetDetailsSlice.actions;

export default vetDetailsSlice.reducer;
